import getConfig from 'next/config';
import { useContext, useEffect, useState } from 'react';
import RootContext from '../../../util/root.context';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import { getCookie } from '../../hooks/useCookie';

const { publicRuntimeConfig } = getConfig();

const EirRegistrationRequiredModal = ({ registrationIncompleteModal }) => {
  const { dispatch } = useContext(RootContext);
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'Registration-not-complete',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  const handleClose = () => {
    registrationIncompleteModal.disable();
    dispatch({ type: 'ENABLE_LOGOUT', payload: false });
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID || ''}
      open={registrationIncompleteModal.value}
      handleClose={registrationIncompleteModal.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url || ''
      }`}
      title={cmsCollectionData?.attributes?.title || ''}
      description={`${cmsCollectionData?.attributes?.firstHalfDescription || ''} ${getCookie(
        'email_Address'
      )} ${cmsCollectionData?.attributes?.secondHalfDescription || ''}`}
      cta={[
        {
          // text: 'Close',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Close',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleClose(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default EirRegistrationRequiredModal;
